<template>
    <v-simple-table>
        <thead style="background: #FF5100">
        <tr>
            <th class="tableTxt pa-2">รหัสกิจกรรม <br> ทางเศรษฐกิจ</th>
            <th class="tableTxt pa-2">รายละเอียด</th>
            <th class="tableTxt pa-2">มูลค่า (ล้านบาท)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,i) in data.tsic_name.length" :key="i">
            <td>{{ data.tsic_code[i] }}</td>
            <td class="text-left">{{ data.tsic_name[i] }}</td>
            <td>{{ formatNumber(data.value[i]) }}</td>
        </tr>
        </tbody>
        <tr id="total" style="background: #507CD6">
            <td colspan="2" class="text-right"><span class="tableTotal">มูลค่ารวมทั้งหมด :</span></td>
            <td><span class="tableTotal">{{ formatNumber(data.sum_value) }}</span></td>
        </tr>
    </v-simple-table>
</template>

<script>
    export default {
        name: "TableData",
        props:['data'],
        methods: {
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            },
        }
    }
</script>

<style scoped>

    .tableTotal {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
    }

    .v-application--is-ltr .v-data-table th {
        text-align: center;
    }

    .tableTxt {
        font-size: 17px;
        color: #fff !important;
    }

    /* table border style */
    .theme--light.v-data-table tbody tr td {
        border-bottom: 1px solid #FF5100 !important;
    }

    .theme--light.v-data-table tbody tr td:not(:last-child) {
        border-right: 1px solid #FF5100;
    }

    .theme--light.v-data-table thead tr:last-child th:not(:last-child) {
        border-right: 1px solid #fff;
    }

    .theme--light.v-data-table tr#total td:nth-child(2) {
        border-right: 1px solid #fff;
    }
    /* end table border style */

</style>
